module.exports = "/static/assets/b08301efa789f34c92da0d7a2edad526.png";